<template>
  <wrapper>
    <main class="main-content-wrapper">
        <div>
            <div class="receipt-header">
                <h4>Buat Purchase Receipt</h4>
                <p>Buat dan kelola tanda terima untuk setiap transaksi pembelian dan penjualan.</p>
            </div>

            <div class="info-section">
                <h5>Informasi Purchase Order</h5>
                
                <div class="info-card">
                    <div class="row px-4">
                        <div class="col-md-6">
                            <div class="info-label">ID Purchase Order</div>
                            <div class="info-value">{{ detailPoData.id }}</div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="info-label">Nama Supplier</div>
                            <div class="info-value">{{ detailPoData.supplier }}</div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- Details Section -->
        <div class="details-header">
            <h5>Details</h5>
        </div>
        <div class="details-section" v-if="itemWithoutSn.length > 0">
            <!-- Table Header -->
            <div class="table-header">
                <div class="table-header-row">
                    <div class="col-item-no">NO ITEM</div>
                    <div class="col-item-name">NAMA ITEM</div>
                    <div class="col-terima">TERIMA SEKARANG</div>
                    <div class="col-sisa">SISA</div>
                    <div class="col-actions"></div>
                </div>
            </div>

            <!-- Items List -->
            <div v-for="item in itemWithoutSn" :key="item.id" class="item-row">
            <div class="col-item-no">
                <div class="item-no">{{ item.itemCode }}</div>
            </div>
            <div class="col-item-name">
                <div class="item-name">{{ item.itemName }}</div>
                <div class="progress-bar-wrapper">
                   <div class="progress-info">
                      <span class="label">Total:</span>
                      <span class="value">{{ item.qtyTotal }}</span>
                      <div class="divider"></div>
                      <span class="label">Sudah Diterima:</span>
                      <span class="value" style="color: #16A34A;">{{ item.qtyReceived }}</span>
                      <span class="percentage">{{ Math.round((item.qtyReceived / item.qtyTotal) * 100) }}%</span>
                    </div>
                    <div class="progress-bar-track">
                      <div class="progress-bar-fill" :style="{ width: Math.round((item.qtyReceived / item.qtyTotal) * 100) + '%' }"></div>
                    </div>
                    <!-- <div class="progress-percentage">{{ Math.round((item.qtyReceived / item.qtyTotal) * 100) }}%</div>
                    <div class="progress">
                        <div class="progress-bar" :style="{ width: (item.qtyReceived/item.qtyTotal)*100 }"></div>
                    </div> -->
                   
                </div>
            </div>
            <div class="col-terima">
                <div class="qty-control">
                <div class="qty-input-wrapper">
                  <input 
                    type="number" 
                    class="qty-input" 
                    v-model.number="item.newReceiveQty"
                    min="0"
                    :max="item.qtyRemaining"
                    @input="validateQty(item)"
                  >
                </div>
                </div>
            </div>
            <div class="col-sisa">
              <div class="qty-box">{{ item.qtyRemaining }}</div>
            </div>
            
            </div>
        </div>

        <!-- Warning Box -->
        <div class="warning-box" v-if="itemSn.length > 0">
            <div style="margin-top: 0.5rem;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2.00073C17.5228 2.00073 22 6.47788 22 12.0007C22 17.5236 17.5228 22.0007 12 22.0007C6.47715 22.0007 2 17.5236 2 12.0007C2 6.47788 6.47715 2.00073 12 2.00073Z" stroke="#973C00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 16.0007V12.0007" stroke="#973C00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 7.99927H12.0109" stroke="#973C00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>  
            </div>
           
            <!-- <i class="fas fa-exclamation-circle"></i> -->
            <div class="warning-content ml-3">
                <div class="warning-title">Beberapa Item Memiliki Serial Number (View-Only)</div>
                <p class="warning-text">Item berikut hanya dapat di receipt melalui ERP dan aplikasi desktop.</p>
            </div>
            <!-- <i class="fas fa-chevron-down expand-icon"></i> -->
            <img
                v-if="!warningExpanded"
                src="~@/assets/icon/arrow-down.png"
                style="width: 15px; margin-top: 1.3rem; cursor: pointer;"
                :class="{ expanded: warningExpanded }"
                @click="toggleWarning()"
            />
            <img
                v-else
                src="~@/assets/icon/arrow-up.png"
                style="width: 15px; margin-top: 1.3rem; cursor: pointer;"
                :class="{ expanded: warningExpanded }"
                @click="toggleWarning()"
            />
        </div>
        <!-- Batch Items Section (Collapsible) -->
        <div class="batch-items-section" :class="{ expanded: warningExpanded }">
            <div class="batch-header">
                <div class="batch-header-row">
                    <div class="batch-col-no">NO ITEM</div>
                    <div class="batch-col-name">NAMA ITEM</div>
                    <div class="batch-col-qty">QTY</div>
                    <div class="batch-col-badge"></div>
                </div>
            </div>
            
            <div v-for="batchItem in itemSn" :key="batchItem.id" class="batch-item-row">
                <div class="batch-col-no">
                    <div class="batch-item-no">{{ batchItem.itemCode }}</div>
                </div>
                <div class="batch-col-name">
                    <div class="batch-item-name">{{ batchItem.itemName }}</div>
                </div>
                <div class="batch-col-qty">
                    <div class="batch-item-qty">{{ batchItem.qtyTotal }}</div>
                </div>
                <div class="batch-col-badge">
                    <span class="badge-no-sn">Has Serial Number</span>
                </div>
            </div>
        </div>

        <div class="action-buttons">
            <button class="btn btn-cancel" @click="toPurchaseReceipt">Batal</button>
            <button :class="`btn ${itemWithoutSn.length == 0 || disableGenerateBtn || loadingButtonProcess ? 'btn-create-disabled' : 'btn-create'}`" @click="createReceipt" :disabled="itemWithoutSn.length == 0 || disableGenerateBtn || loadingButtonProcess">
              Buat Purchase Receipt
            </button>
        </div>
    </main>
    <!-- /#page-content-wrapper -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, Card } from "../Layout";
import Swal from "sweetalert2";

export default {
  name: "ReceiptCreationPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      warningExpanded : false,
      detailPoData : '',
      itemSn : [],
      itemWithoutSn : [],

      admin: "",
      adminId: "",
      permission: [],
      viewDashboard: false,
      editPurchaseReceipt : false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonNext: false,
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      loadingTable: true,
      itemPerPage: 10,
    };
  },
  computed: {
    disableGenerateBtn() {
      // Disable jika tidak ada item sama sekali
      if (!this.itemWithoutSn || this.itemWithoutSn.length === 0) return true;
      
      // Disable jika semua item qty-nya 0 atau kosong
      const totalQty = this.itemWithoutSn.reduce((sum, item) => {
        return sum + (Number(item.newReceiveQty) || 0);
      }, 0);

      return totalQty === 0;
    }
  },
  methods: {
    toPurchaseReceipt() {
      this.$router.push({
        path: '/purchase/receipt',
        query: {
            poId : '',
            supplierName : '',
            createdDate : '',
            status : '',
            page : 1,
            itemPerPage : 10,
        }
      })
    },
    validateQty(item) {
      if (item.newReceiveQty > item.qtyRemaining) {
        item.newReceiveQty = item.qtyRemaining;
      }
      if (item.newReceiveQty < 0 || isNaN(item.newReceiveQty)) {
        item.newReceiveQty = 0;
      }
    },
    createReceipt() {
        this.loadingButtonProcess = true
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });

        const {id, status, supplier, createdDate, total,items } = this.detailPoData

        let newItemsData = this.itemWithoutSn.map(item => {
          const {newReceiveQty} = item
          return {
            ...item,
            qtyReceived : newReceiveQty 
          }
        })

        this.$http.post(process.env.CREATE_PURCHASE_RECEIPT, {
                id,
                status,
                supplier,
                createdDate,
                total,
                items : newItemsData,
            },
            {
                headers : {'Asani-Token': localStorage.getItem('jwt')}
            }
        )
        .then(response => {
            this.loadingButtonProcess = false
            if(response.data.status == 200) {
                swalWithBootstrapButtons.fire({
                    title: "Success",
                    text: `Berhasil buat receipt`,
                    icon: "success",
                }).then(result => {
                    window.location.reload()
                })
            } else {
                swalWithBootstrapButtons.fire({
                    title: "Failed",
                    text: `${response.data.message}`,
                    icon: "error",
                }).then(result => {
                   window.location.reload()
                })
            }
        })
        .catch(err => {
            this.loadingButtonProcess = false
            swalWithBootstrapButtons.fire({
                title: "Failed",
                text: `${err.message}`,
                icon: "error",
            }).then(result => {
                $(`#modalDetailPo`).modal('hide')
            })
        })
    },
    toggleWarning() {
      this.warningExpanded = !this.warningExpanded;
    },
    getStatusClass(status) {
      if (status === 'To Receive') return 'status-to-receive';
      if (status === 'To Bill & Receive') return 'status-to-bill-receive';
      if (status === 'To Bill') return 'status-to-bill';
      return '';
    },
    toPartCompabilityDetail(data) {
      this.$router.push({
        path: "/catalog/part-compability/detail/" + data.itemCode,
        query: {
          itemName : data.itemName,
          itemGroup : data.itemGroup,
        }
      });
    },

    resetSearch() {
      this.searchSupplierName = "";
      this.searchPoID = "";
      this.searchDateCreated = "";
      this.searchStatus = { status: "All", statusName: "All" };
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.searchData();
    },

    searchData() {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
            poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus,
            dateCreated : this.searchDateCreated,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPage(pagePost) {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
            poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus.status,
            dateCreated : this.searchDateCreated,
            page: pagePost,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPerPage() {
      this.$router.push(
        {
          path:'/purchase/receipt', 
          query: {
            poId: this.searchPoID,
            supplierName: this.searchSupplierName,
            status: this.searchStatus.status,
            dateCreated : this.searchDateCreated,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },

    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
        if(this.permission[i] == '25.2') {
          this.editPurchaseReceipt = true
        }
      }
      if (this.editPurchaseReceipt == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    getDataDetail() {
        this.$http.post(process.env.GET_PO_DETAIL, {
            id: this.$route.query.poId,
            docType: 'PO',
        },
        {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
            if(response.data.status == 200) {
              this.detailPoData = {...response.data.data}
              this.itemWithoutSn = this.detailPoData.items ? this.detailPoData.items.filter(item => !item.hasSerialNo).map(item => ({
                ...item,
                newReceiveQty : 0
              })) : []
              this.itemSn = this.detailPoData.items ? this.detailPoData.items.filter(item => item.hasSerialNo) : this.itemSn
            } else {
              swal("Error", response.data.message, "error");
            }
        })
        .catch(err => {
            swal("Error", err.message, "error");
        })
    },
    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    this.getDataDetail()
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.receipt-header {
  background: linear-gradient(90deg, #F5FAFF 0%, #E0F0FE 100%);
  border: 1px solid #bce8f1;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}
.receipt-header h4 {
  color: #2E3646;
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
}
.receipt-header p {
  color: #6A7282;
  margin: 0;
  font-size: 14px;
}
.info-card {
    border: 1px solid #D1D9E2;
    border-radius: 4px;
    padding: 20px;
}
.info-section h5 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;

}
.info-label {
  color: #666;
  font-size: 13px;
  margin-bottom: 5px;
}
.info-value {
  color: #333;
  font-size: 14px; 
  font-weight: 500;
}
.expand-icon {
    color: #856404;
    cursor: pointer;
    font-size: 18px;
}
.action-buttons {
    margin-top: 20px;
    text-align: right;
}
.btn-cancel {
    background-color: white;
    border: 1px solid #ddd;
    color: #333;
    padding: 8px 24px;
    margin-right: 10px;
}
.btn-create {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 8px 24px;
}

.btn-create-disabled {
  background-color: #D1D5DC;
  border: none;
  color: white;
  padding: 8px 24px;
}

.btn-create:hover {
    background-color: #0056b3;
}
.link-text {
    color: #007bff;
    cursor: pointer;
    text-decoration: none;
}
.link-text:hover {
    text-decoration: underline;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}

    .details-section {
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      padding: 0;
      margin-top: 20px;
    }
    .details-header {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .details-header h5 {
      color: #333;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
    }
    .table-header {
      background-color: #f8f9fa;
      padding: 12px 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .table-header-row {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 600;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .col-item-no {
      width: 10%;
    }
    .col-item-name {
      width: 50%;
    }
    .col-terima {
      width: 20%;
      text-align: center;
    }
    .col-sisa {
      width: 20%;
      text-align: center;
    }
    .item-row {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      display: flex;
      align-items: center;
    }
    .item-row:last-child {
      border-bottom: none;
    }
    .item-no {
      color: #6c757d;
      font-size: 14px;
      font-weight: 500;
    }
    .item-name {
      color: #212529;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .item-info {
      display: flex;
      gap: 15px;
      font-size: 12px;
      color: #6c757d;
      margin-bottom: 8px;
    }
    .item-info span {
      display: flex;
      align-items: center;
    }
    .progress-bar-wrapper {
      width: 100%;
      margin-top: 8px;
    }
    .progress {
      height: 6px;
      background-color: #e9ecef;
      border-radius: 3px;
      overflow: hidden;
    }
    .progress-bar {
      height: 100%;
      background-color: #007bff;
      transition: width 0.3s ease;
    }
    .progress-percentage {
      font-size: 11px;
      color: #6c757d;
      margin-top: 4px;
      text-align: right;
    }
    /* New Progress bar */
    .progress-info {
      display: flex;
      align-items: center;
      gap: 0;
      margin-bottom: 8px;
      font-size: 13px;
      color: #495057;
    }
    .progress-info .divider {
      width: 1px;
      height: 14px;
      background: #dee2e6;
      margin: 0 12px;
    }
    .progress-info .label { color: #6c757d; }
    .progress-info .value { font-weight: 600; color: #212529; margin-left: 4px; }
    .progress-info .percentage {
      margin-left: auto;
      font-weight: 600;
      color: #495057;
      font-size: 13px;
    }
    .progress-bar-track {
      width: 100%;
      height: 6px;
      background: #e9ecef;
      border-radius: 99px;
      overflow: hidden;
    }
    .progress-bar-fill {
      height: 100%;
      background: #1a73e8;
      border-radius: 99px;
      transition: width 0.5s ease;
    }
    /* End og progress bar */
    .qty-input {
      width: 100%;
      max-width: 120px;
      margin: 0 auto;
      display: block;
      text-align: center;
      border: 1px solid #ced4da;
      border-radius: 4px;
      padding: 8px 12px;
      font-size: 14px;
    }
    .qty-input:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }

    .qty-box {
      width: 35px;
      height: 35px;
      background: #f1f3f5;
      border-radius: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
      color: #1a73e8;
    }

    /* Batch Items Section */
    .batch-items-section {
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      padding: 0;
      margin-top: 15px;
      overflow: hidden;
      max-height: 0;
      transition: max-height 0.3s ease;
    }
    .batch-items-section.expanded {
      max-height: 1000px;
    }
    .batch-header {
      background-color: #f8f9fa;
      padding: 12px 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .batch-header-row {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 600;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .batch-col-no {
      width: 15%;
    }
    .batch-col-name {
      width: 50%;
    }
    .batch-col-qty {
      width: 20%;
      text-align: center;
    }
    .batch-col-badge {
      width: 15%;
      text-align: right;
    }
    .batch-item-row {
      padding: 15px 20px;
      border-bottom: 1px solid #e9ecef;
      display: flex;
      align-items: center;
    }
    .batch-item-row:last-child {
      border-bottom: none;
    }
    .batch-item-no {
      color: #6c757d;
      font-size: 13px;
    }
    .batch-item-name {
      color: #212529;
      font-size: 14px;
    }
    .batch-item-qty {
      text-align: center;
      color: #212529;
      font-size: 14px;
    }
    .badge-no-sn {
      background: #FEE2E2;
      color: #DC2626;
      border: 1px solid #FCA5A5;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
      padding: 4px 10px;
      white-space: nowrap;
    }
    .warning-box {
      background-color: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 4px;
      padding: 15px;
      margin-top: 20px;
      display: flex;
      align-items: flex-start;
    }
    .warning-box i {
      color: #856404;
      margin-right: 15px;
      font-size: 20px;
      margin-top: 2px;
    }
    .warning-content {
      flex: 1;
    }
    .warning-title {
      color: #856404;
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 5px;
    }
    .warning-text {
      color: #856404;
      font-size: 13px;
      margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Purchase/PurchaseReceiptCreationPage.vue